import { render, staticRenderFns } from "./Bangbangpinche.vue?vue&type=template&id=3096d2e8&scoped=true&"
import script from "./Bangbangpinche.vue?vue&type=script&lang=js&"
export * from "./Bangbangpinche.vue?vue&type=script&lang=js&"
import style0 from "./Bangbangpinche.vue?vue&type=style&index=0&id=3096d2e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3096d2e8",
  null
  
)

export default component.exports